import type { IconSvgObject } from './types';

const WindowsOldIcon: IconSvgObject = [
  ["path", { d: "M18.6712 3.02771L4.6712 5.36104C3.70683 5.52177 3 6.35615 3 7.33383V16.6667C3 17.6443 3.70683 18.4787 4.6712 18.6395L18.6712 20.9728C19.8903 21.176 21 20.2359 21 19V5.00049C21 3.76462 19.8903 2.82453 18.6712 3.02771Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11 4.5V19.5M3 12H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default WindowsOldIcon;
